module.exports = __webpack_public_path__ + "static/media/background-gray.4d758ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-gray.png
// module id = 1009
// module chunks = 0